import { useLang } from "@/context/LanguageContext";

/**
 * VENDIDA / SOLD badge for LATIR.
 * - Red institutional background, white text.
 * - Compact pill; matches the existing font-ui + tracking used across the site.
 */
export function SoldBadge({ className = "", size = "md", testId = "sold-badge" }) {
  const { lang } = useLang();
  const text = lang === "en" ? "SOLD" : "VENDIDA";
  const sizeCls =
    size === "sm"
      ? "px-2 py-[3px] text-[0.62rem]"
      : "px-2.5 py-1 text-[0.7rem]";
  return (
    <span
      data-testid={testId}
      className={
        "inline-flex items-center rounded-[3px] bg-latir-red text-paper " +
        "font-ui uppercase tracking-[0.22em] leading-none " +
        sizeCls +
        (className ? " " + className : "")
      }
    >
      {text}
    </span>
  );
}

export default SoldBadge;
